import React, { Dispatch } from 'react';
import Translator from '../../../../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../../../../core/common';
import { IAppState, IAction } from '../../../../../models/action/core';
import { connect } from 'react-redux';
import { IMatrixProps, IUserResponses } from '../../../../../models/components/activity-card-survey';
import { IMatrixQuestion, IQuestionChoice } from '../../../../../models/components/add-activity-survey-questions';

const T = Translator.create();
const _logger = Log.create('Survey Matrix');
let _common: Common;

interface IChoiceState {
    selectedIds: IUserResponses[];
}

class Matrix extends React.Component<IMatrixProps, IChoiceState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

    }

    state: IChoiceState = {
        selectedIds: []
    };

    setDefaultValue = () => {
        const userResponses = this.props.formik!.values.userResponses;
        const questionIds: string[] = [];

        if (this.props.question.matrixQuestions) {
            this.props.question.matrixQuestions.forEach(element => {
                questionIds.push(element.surveyQuestionId);
            });
        }

        const _selectedIds = this.state.selectedIds;
        userResponses.filter(r => questionIds.indexOf(r.surveyQuestionId) !== -1).forEach(element => {
            _selectedIds.push(element);
        });
        this.setState({ selectedIds: _selectedIds });
    }

    componentDidMount() {
        this.setDefaultValue();
    }

    returnChoices = (question: IMatrixQuestion): IQuestionChoice[] => {
        const choices: IQuestionChoice[] = [];

        if (this.props.question.matrixQuestionChoiceIds && this.props.question.questionChoices) {
            this.props.question.questionChoices
                .sort((a, b) => a.displayOrder - b.displayOrder)
                .forEach(choice => {
                    const choiceId = this.props.question.matrixQuestionChoiceIds!.find(
                        _choiceId =>
                            _choiceId.displayOrder === choice.displayOrder && _choiceId.surveyQuestionId === question.surveyQuestionId
                    );
                    if (choiceId) {
                        choices.push({
                            surveyQuestionChoiceId: choiceId.surveyQuestionChoiceId,
                            text: choice.text,
                            surveyQuestionId: question.surveyQuestionId,
                            displayOrder: choice.displayOrder
                        });
                    }
                });
        }

        return choices;
    };

    onChoose = (surveyQuestionId: string, surveyQuestionChoiceId: string) => {
        const userResponses = this.props.formik!.values.userResponses;
        let response: IUserResponses | undefined;
        let responseIndex = -1;

        responseIndex = userResponses.findIndex(
            (_response: IUserResponses) => _response.surveyQuestionId === surveyQuestionId
        );

        if (responseIndex !== -1) {
            response = userResponses.find((_response: IUserResponses) => _response.surveyQuestionId === surveyQuestionId);
        }

        if (response && responseIndex !== -1) {
            response.surveyQuestionChoiceId = surveyQuestionChoiceId;
            userResponses.splice(responseIndex, 1);
            userResponses.push(response);
        } else {
            response = { surveyQuestionId, surveyQuestionChoiceId };
            userResponses.push(response);
        }

        this.setState({ selectedIds: userResponses });
        this.props.formik!.setFieldValue('userResponses', userResponses);
    };

    public render() {
        return (
            <div className="w-100 table-responsive" key={this.props.key}>
                <table className="table survey_table">
                    <thead>
                        <tr className="choose_col">
                            <th className="first_th_blank" />
                            {this.props.question.questionChoices
                                ? this.props.question.questionChoices
                                      .sort((a, b) => a.displayOrder - b.displayOrder)
                                      .map((choice, index) => (
                                          <th key={index} className="first_th">
                                              {choice.text}
                                          </th>
                                      ))
                                : ''}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.question.matrixQuestions
                            ? this.props.question.matrixQuestions
                                  .sort((a, b) => a.displayOrder - b.displayOrder)
                                  .map((question, index) => (
                                      <tr key={index} className="choose_row">
                                          <td className="first_td">{question.description}</td>
                                          {this.returnChoices(question).map((choice, choiceIndex) => (
                                              <td key={choiceIndex}>
                                                  <div 
                                                    className={
                                                        this.state.selectedIds.findIndex(s => s.surveyQuestionId === question.surveyQuestionId && s.surveyQuestionChoiceId === choice.surveyQuestionChoiceId) !== -1
                                                            ? 'control-group survey_choose'
                                                            : 'control-group survey_choose'
                                                    }
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={this.onChoose.bind(this, question.surveyQuestionId, choice.surveyQuestionChoiceId)}>
                                                      <span className="control control--radio">
                                                          <input 
                                                          checked={
                                                            this.state.selectedIds.findIndex(s => s.surveyQuestionId === question.surveyQuestionId && s.surveyQuestionChoiceId === choice.surveyQuestionChoiceId) !== -1
                                                          }
                                                          onChange={this.onChoose.bind(this, question.surveyQuestionId, choice.surveyQuestionChoiceId)}   
                                                          type="radio" name={question.surveyQuestionId} />
                                                          <div className="control__indicator" />
                                                      </span>
                                                  </div>
                                              </td>
                                          ))}
                                      </tr>
                                  ))
                            : ''}
                    </tbody>
                </table>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IMatrixProps): IMatrixProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IMatrixProps = Object.assign({}, ownProps, {
        surveyChoices: state.coursePage.surveyChoices
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.surveyChoices === prev.coursePage.surveyChoices;
    return ret;
};

const CMatrix = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Matrix);

export default CMatrix;
